export function countryCodeToName(countryCode: string, language: string = 'ru') {
  return new Intl.DisplayNames([language], {type: 'region'}).of(countryCode);
}
